import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="csv-export-dialog"
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // Add event listener for ESC key
    document.addEventListener('keydown', this.keydown.bind(this))
  }
  
  disconnect() {
    // Remove event listener when controller is disconnected
    document.removeEventListener('keydown', this.keydown.bind(this))
  }

  openDialog(event) {
    if (event) event.preventDefault()
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
    this.dialogTarget.classList.add("items-center")
    this.dialogTarget.classList.add("justify-center")
    document.body.classList.add("overflow-hidden")
  }

  closeDialog() {
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
    this.dialogTarget.classList.remove("items-center")
    this.dialogTarget.classList.remove("justify-center")
    document.body.classList.remove("overflow-hidden")
  }

  // Close when clicking outside the modal content
  backgroundClick(event) {
    if (event.target === this.dialogTarget) {
      this.closeDialog()
    }
  }

  // Close when pressing Escape
  keydown(event) {
    if (event.key === "Escape") {
      this.closeDialog()
    }
  }

  // Handle the export action
  export() {
    // Get the current URL and query parameters
    const baseUrl = window.location.pathname.replace(/\/$/, '')
    const queryParams = window.location.search
    
    // Create the CSV URL with the current filters
    const csvUrl = `${baseUrl}.csv${queryParams}`
    
    // Navigate to the CSV URL
    window.location.href = csvUrl
    
    // Close the dialog
    this.closeDialog()
  }
}
